<template>
  <div
    class="page_top_area"
    :class="{
      [variant]: !!variant
    }"
  >
    <div class="inner-width">
      <slot />
      <div class="title_area">
        <div class="cn">
          {{ titleCh }}
        </div>
        <span
          v-if="titleDivider"
          class="divider"
        />
        <div
          class="en"
          style="letter-spacing:5px;"
        >
          {{ titleEn }}
        </div>
      </div>
      <div
        v-if="breadcrumbItems.length > 1"
        class="breadcrumb_area"
      >
        <ul class="breadcrumb_list clearfix">
          <li
            v-for="(breadcrumb, index) in breadcrumbItems"
            :key="index"
            class="breadcrumb_item"
          >
            <template v-if="breadcrumb.path">
              <router-link :to="breadcrumb.path">
                {{ breadcrumb.text }}
              </router-link>
            </template>
            <template v-else>
              {{ breadcrumb.text }}
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: {
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    },
    titleDivider: {
      type: Boolean,
      default: false
    },
    breadcrumbItems: {
      type: Array,
      default: () => [{
        text: '首頁',
        path: '/'
      }]
    },
    variant: {
      type: String,
      default: ''
    }
  }
}
</script>
